module.exports = __webpack_public_path__ + "img/Google.a8fd902b.svg";